import { Divider, Stack, Typography } from "@mui/material";

export default function StudentTabContainer({ children, title, content }) {
  return (
    <Stack sx={{ px: 2, py: 1 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        py={1}
      >
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>

        <Stack>{content}</Stack>
      </Stack>
      <Divider />
      {children}
    </Stack>
  );
}
